/** Accessibility skip-link — moves keyboard focus into <main>. */
export function SkipToMainLink() {
  return (
    <a
      href="#pd-main-content"
      className="pd-skip-link"
      data-testid="skip-to-main"
      onClick={(e) => {
        // Move keyboard focus into <main> for AT/keyboard users (not just URL anchor)
        e.preventDefault();
        const main = document.getElementById('pd-main-content');
        if (main) {
          main.focus();
          main.scrollIntoView({ behavior: 'auto' });
        }
      }}
    >
      Skip to main content
    </a>
  );
}
